import { apiClient } from "../Config/ApiClient";

export const retrieveMarketSummary = (params, token) => apiClient.get(`/mktsum/mktsum-info`, { params: params, headers: { 'Authorization': token } })